import { ArrowRight, MailCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

export function LandingPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-mb-bg">
      <header className="border-b border-mb-border bg-mb-surface-elev px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-md bg-mb-accent flex items-center justify-center font-display font-bold text-mb-accent-fg">
            M
          </div>
          <div className="font-display font-semibold text-mb-text">MailingBees</div>
        </div>
        <nav className="flex items-center gap-3">
          <Link to="/login" className="text-sm text-mb-text-muted hover:text-mb-text">
            Sign in
          </Link>
          <Link to="/signup" className="mb-btn-primary">
            Get started
          </Link>
        </nav>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-20">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 rounded-pill bg-mb-accent-soft px-3 py-1 text-xs text-mb-accent-press mb-6">
            <MailCheck className="h-3.5 w-3.5" />
            Cold email that doesn&rsquo;t suck
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-mb-text tracking-tight">
            In-house Instantly. Own your infra.
          </h1>
          <p className="mt-4 text-lg text-mb-text-muted max-w-xl mx-auto">
            Rotate mailboxes, warm sends, AI-classify replies, and pay ~$13/month
            fixed plus $6 per connected Gmail. Nothing per-lead. Nothing per-email.
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/signup" className="mb-btn-primary">
              Create your organization
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/login" className="mb-btn-secondary">
              I already have an account
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
